export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-cover-58d822fbcc01e8e94ea27ea11872e2e7.png";